import * as React from "react";

interface Props {
    name: string;
    size?: number;
}

function getInitials(name: string): string {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return "?";
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
}

export function InitialsAvatar({ name, size = 44 }: Props) {
    return (
        <div
            className="flex shrink-0 items-center justify-center rounded-xl border border-gray-200 bg-gray-50 font-semibold text-gray-500"
            style={{ width: size, height: size, fontSize: size * 0.34 }}
        >
            {getInitials(name)}
        </div>
    );
}
